import { render } from "./discount.vue?vue&type=template&id=3814d2b9&scoped=true&ts=true"
import script from "./discount.vue?vue&type=script&lang=ts"
export * from "./discount.vue?vue&type=script&lang=ts"

import "./discount.vue?vue&type=style&index=0&id=3814d2b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3814d2b9"]])

export default __exports__